import { ItemButtonModel } from '../item-button/item-button.model';

export enum EmailAttachmentPickerValueItemTypeEnum {
    REPORT = 1,
    FILE = 2
}

export interface EmailAttachmentPickerValueItem extends ItemButtonModel {
    type: EmailAttachmentPickerValueItemTypeEnum;
}

export declare type EmailAttachmentPickerValue = Array<EmailAttachmentPickerValueItem>;



// WEBPACK FOOTER //
// ./src/app/atoms/email-attachment-picker/email-attachment-picker-value.ts